import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { SubpageBanner, SectionHeader } from 'components';

const Banner = () => (
  <StaticQuery
    query={graphql`
      query {
        mainBannerImage: file(
          relativePath: {
            eq: "machine-learning/developers-working-on-machine-learning-algoritm.png"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <SubpageBanner
        backgroundColor={'pigeon-post'}
        image={data.mainBannerImage.childImageSharp.fluid}
        additionalClass={'machine-learning__banner'}
        alt={'Developers working on machine learning algoritm'}
      >
        <SectionHeader
          size={'large'}
          color={'white'}
          lineColor={'red'}
          description={
            'Startups, enterprise businesses and corporations around the world employ artificial intelligence (AI) to gain competitive edge, serve their customers better and support their decision-making processes.'
          }
          hiddenDescription={
            '<br />Boldare’s AI team can help your company apply machine learning, deep neural networks and ready-made SaaS solutions to support your growth. Our team will carry out research and development, prepare your data, build the model, code it, implement the solution and integrate it with your existing software.'
          }
          descriptionColor={'white'}
          fixed
          additionalClass={'section-header__description--medium'}
        >
          Machine Learning
          <br />
          services
        </SectionHeader>
      </SubpageBanner>
    )}
  />
);

export default Banner;
